<!-- ラジオボタン式で、１枚のみ購入可能なチケット -->
<template>
  <div class="radio-area">
    <!-- dataDivisionsをループして表示 -->
    <div v-for="(division, index) in dataDivisions" :key="index">
      <div class="radio">
        <input
          :id="'radio-' + index"
          name="radio"
          type="radio"
          v-model="radio"
          :value="index"
          @change="changeRadio(index)"
        />
        <label :for="'radio-' + index" class="radio-label">
          {{ division.name }}: 1枚
        </label>
      </div>

      <!-- 赤のエラー文言 -->
      <p class="error-block" v-if="division.maxPurchaseCount < division.count">
        ※{{
          division.name
        }}区分のチケットをこれ以上所持することは<br />できません
      </p>
    </div>
  </div>
  <!-- ラジオボタン式で購入可能なチケット -->
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";

export default {
  name: "TheMbDivisionCountRadio",
  props: {
    dataDivisions: Array,
    changeRadio: Function,
  },
  setup(props) {
    const radio = ref(0);

    onMounted(async () => {
      // 購入可能なdivisionを選択状態に設定
      for (var i = 0; i < props.dataDivisions.length; i++) {
        if (
          props.dataDivisions[i].maxPurchaseCount > 0 &&
          props.dataDivisions[i].count > 0
        ) {
          radio.value = i;
          break;
        }
      }
    });

    return {
      radio,
    };
  },
};
</script>

<style lang="scss">
.radio-select {
  display: block;
  margin: 1rem;
  font-size: 1.3rem;
}

$color1: #f4f4f4;
$color2: #3197ee;
.radio-area {
  margin: 15px;
}
.margin50 {
  margin: 50px 0;
}

.error-block {
  margin: 5px 0 0 0;
  font-size: 13px !important;
  font-weight: bold;
  text-align: right;
  line-height: 17px;
  color: #ff3333;
}

.radio {
  margin: 1rem;
  input[type="radio"] {
    position: absolute;
    opacity: 0;
    + .radio-label {
      &:before {
        content: "";
        background: $color1;
        border-radius: 100%;
        border: 1px solid darken($color1, 25%);
        display: inline-block;
        width: 1.4em;
        height: 1.4em;
        position: relative;
        top: -0.2em;
        margin-right: 1em;
        vertical-align: top;
        cursor: pointer;
        text-align: center;
        transition: all 250ms ease;
      }
    }
    &:checked {
      + .radio-label {
        &:before {
          background-color: $color2;
          box-shadow: inset 0 0 0 4px $color1;
        }
      }
    }
    &:focus {
      + .radio-label {
        &:before {
          outline: none;
          border-color: $color2;
        }
      }
    }
    &:disabled {
      + .radio-label {
        &:before {
          box-shadow: inset 0 0 0 4px $color1;
          border-color: darken($color1, 25%);
          background: darken($color1, 25%);
        }
      }
    }
    + .radio-label {
      &:empty {
        &:before {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
